// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1Ffgq","savePackageButton":"ClientWallet_savePackageButton__1Ktm-"};